// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountTypeDescriptionController from "./account_type_description_controller"
application.register("account-type-description", AccountTypeDescriptionController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import ArchivedHighlightController from "./archived_highlight_controller"
application.register("archived-highlight", ArchivedHighlightController)

import AutoscrollController from "./autoscroll_controller"
application.register("autoscroll", AutoscrollController)

import CalendarTableController from "./calendar_table_controller"
application.register("calendar-table", CalendarTableController)

import CashflowChartsController from "./cashflow_charts_controller"
application.register("cashflow-charts", CashflowChartsController)

import CollapseVisibilityController from "./collapse_visibility_controller"
application.register("collapse-visibility", CollapseVisibilityController)

import CostCentreShortNameGeneratorController from "./cost_centre_short_name_generator_controller"
application.register("cost-centre-short-name-generator", CostCentreShortNameGeneratorController)

import CostCentreToggleController from "./cost_centre_toggle_controller"
application.register("cost-centre-toggle", CostCentreToggleController)

import DeletionConfirmationController from "./deletion_confirmation_controller"
application.register("deletion-confirmation", DeletionConfirmationController)

import DeletionStatusRefreshController from "./deletion_status_refresh_controller"
application.register("deletion-status-refresh", DeletionStatusRefreshController)

import DisableSubmitController from "./disable_submit_controller"
application.register("disable-submit", DisableSubmitController)

import EventBusController from "./event_bus_controller"
application.register("event-bus", EventBusController)

import EventDispatcherController from "./event_dispatcher_controller"
application.register("event-dispatcher", EventDispatcherController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InstalmentsController from "./instalments_controller"
application.register("instalments", InstalmentsController)

import JoblinesController from "./joblines_controller"
application.register("joblines", JoblinesController)

import LedgerDeletionController from "./ledger_deletion_controller"
application.register("ledger-deletion", LedgerDeletionController)

import LogToggleController from "./log_toggle_controller"
application.register("log-toggle", LogToggleController)

import ManualCategorisationGuardrailController from "./manual_categorisation_guardrail_controller"
application.register("manual-categorisation-guardrail", ManualCategorisationGuardrailController)

import MortgageCalculatorController from "./mortgage_calculator_controller"
application.register("mortgage-calculator", MortgageCalculatorController)

import MortgagePlaygroundController from "./mortgage_playground_controller"
application.register("mortgage-playground", MortgagePlaygroundController)

import OnEventController from "./on_event_controller"
application.register("on-event", OnEventController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PcDrilldownController from "./pc_drilldown_controller"
application.register("pc-drilldown", PcDrilldownController)

import PeriodicityController from "./periodicity_controller"
application.register("periodicity", PeriodicityController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import RuleBuilderController from "./rule_builder_controller"
application.register("rule-builder", RuleBuilderController)

import RuleLinesController from "./rule_lines_controller"
application.register("rule-lines", RuleLinesController)

import ScheduleShortcutController from "./schedule_shortcut_controller"
application.register("schedule-shortcut", ScheduleShortcutController)

import SmartScenarioAdjustmentController from "./smart_scenario_adjustment_controller"
application.register("smart-scenario-adjustment", SmartScenarioAdjustmentController)

import SmartScenarioAdjustmentsController from "./smart_scenario_adjustments_controller"
application.register("smart-scenario-adjustments", SmartScenarioAdjustmentsController)

import SmartScheduleConfirmationController from "./smart_schedule_confirmation_controller"
application.register("smart-schedule-confirmation", SmartScheduleConfirmationController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SplitController from "./split_controller"
application.register("split", SplitController)

import SplitSourceController from "./split_source_controller"
application.register("split-source", SplitSourceController)

import SplitSuggestionsController from "./split_suggestions_controller"
application.register("split-suggestions", SplitSuggestionsController)

import DisclosureStateController from "./disclosure_state_controller"
application.register("disclosure-state", DisclosureStateController)

import TurbomodalController from "./turbomodal_controller"
application.register("turbomodal", TurbomodalController)

import CreationStatusRefreshController from "./creation_status_refresh_controller"
application.register("creation-status-refresh", CreationStatusRefreshController)

import CategorisationController from "./categorisation_controller"
application.register("categorisation", CategorisationController)

import RentCollectionRuleController from "./rent_collection_rule_controller"
application.register("rent-collection-rule", RentCollectionRuleController)

import RentReceiptController from "./rent_receipt_controller"
application.register("rent-receipt", RentReceiptController)
